import { ADD_PARKING_TABLE_INFO, RESET_PARKING_TABLE_INFO } from "./parkingTagTableReducer"

export const addParkingTableInfo = (obj) => ({
    type: ADD_PARKING_TABLE_INFO,
    payload: obj
})

export const resetParkingTableInfo = () => ({
    type: RESET_PARKING_TABLE_INFO,
})